// $(function () {
// var
// $brandNav = $('.brandList__nav'),
// $anchor = $('.wrap'),
// barHeight = 50,
// timer = null,
// offsetTop = $brandNav.offset().top;
// $(window).on('scroll', function () {
// // もし「ページ最上部からスクロールした位置」までの距離がナビゲーションのある位置を越えたら
// if ($(window).scrollTop() + barHeight > offsetTop) {
// fixNav();
// } else {
// clearNavStyle();
// }
// });
// $(window).on('resize', function () {
// // リサイズが終わった時だけ処理する
// if (timer) clearTimeout(timer);
// timer = setTimeout(function () {
// clearNavStyle();
// fixNav();
// }, 200);
// });
// // ページの途中を読み込んでもスクロールイベントを強制的に発火させる
// $('body').trigger('scroll');
// function fixNav () {
// var navOffsetleft = $brandNav.offset().left;
// $brandNav.css({
// position: 'fixed',
// top: barHeight,
// left: navOffsetleft
// });
// }
// function clearNavStyle() {
// $brandNav.css({
// position: '',
// top: '',
// left: ''
// });
// }
// });
// $('.brandList__nav a').on('click', function (ev) {
// // aリンクの標準動作をキャンセル
// ev.preventDefault();
// var $target = null;
// var offsetTop = null;
// var barHeight = 50;
// // 対象要素それぞれに対して処理を行う
// $('.brandList__index').each(function (idx, el) {
// // ev.currentTargetはクリックされた要素
// // elは現在処理中の要素
// // $().text()はエレメントが内包するテキスト(例: <a>ここ<\\/a>)
// if ($(ev.currentTarget).text() === $(el).text())
// $target = $(el);
// });
// // 「ページ最上部から要素までの距離」からバーの高さを引く
// offsetTop = $target.offset().top - barHeight;
// // 250ミリ秒かけて指定の位置まで移動
// $('html, body').animate({scrollTop: offsetTop}, 250);
// });
